import { useUploadTaskStore, selectActiveTaskCount } from '../store/uploadTaskStore';

/**
 * 侧边栏角标数字 = 进行中的批次任务数（uploading + saving）。
 * 为 0 时不渲染角标。
 */
export const useUploadTaskBadgeCount = () => useUploadTaskStore(selectActiveTaskCount);
